import { ThemeColors } from '~/themes/colors'

interface VariationColors {
  Background: ThemeColors
  Hover: {
    Background: ThemeColors
  }
  Label: {
    FontColor: ThemeColors
  }
  SecondaryLabel: {
    FontColor: ThemeColors
  }
  ChevronIcon: {
    FontColor: ThemeColors
  }
}

interface QueueControlButtonColors {
  InQueue: VariationColors
  OutOfQueue: VariationColors
  DoNotDisturb: VariationColors
}
export const queueControlButtonColors: QueueControlButtonColors = {
  InQueue: {
    Background: {
      default: 'green.600',
    },
    Hover: {
      Background: {
        default: 'green.500',
      },
    },
    Label: {
      FontColor: {
        default: 'white',
      },
    },
    SecondaryLabel: {
      FontColor: {
        default: 'white',
      },
    },
    ChevronIcon: {
      FontColor: {
        default: 'white',
      },
    },
  },
  OutOfQueue: {
    Background: {
      default: 'gray.400',
    },
    Hover: {
      Background: {
        default: 'gray.500',
      },
    },
    Label: {
      FontColor: {
        default: 'gray.1300',
      },
    },
    SecondaryLabel: {
      FontColor: {
        default: 'gray.1300',
      },
    },
    ChevronIcon: {
      FontColor: {
        default: 'gray.1300',
      },
    },
  },
  DoNotDisturb: {
    Background: {
      default: 'red.800',
    },
    Hover: {
      Background: {
        default: 'red.700',
      },
    },
    Label: {
      FontColor: {
        default: 'white',
      },
    },
    SecondaryLabel: {
      FontColor: {
        default: 'white',
      },
    },
    ChevronIcon: {
      FontColor: {
        default: 'white',
      },
    },
  },
}
